import { Badge, Menu, UnstyledButton } from '@mantine/core';
import { useState } from 'react';
import { ChevronDown, CircleCheck, CircleX } from 'tabler-icons-react';
import { SettlementStatus } from '../../../enums/settlement-status.enum';
import ApproveSettlementModal from '../../modals/approve-settlement-modal.component';
import PendingSettlementModal from '../../modals/pending-settlement-modal.component';
import './settlement-pending-dropdown.styles.css';
interface Props {
  settlementId: number;
  setRefreshTable: React.Dispatch<React.SetStateAction<boolean>>;
  status: SettlementStatus;
  isViewOnly: boolean;
  isAdmin: boolean;
}
function SettlementStatusDropdown(props: Props) {
  const { settlementId, setRefreshTable, status, isViewOnly, isAdmin } = props;
  const [isApprovedSettlementModalOpen, setIsApprovedSettlementModalOpen] =
    useState(false);
  const [isPendingSettlementModalOpen, setIsPendingSettlementModalOpen] =
    useState(false);

  const capitalized = () => {
    return status.charAt(0) + status.slice(1).toLowerCase();
  };

  return (
    <>
      {!isViewOnly ? (
        <>
          <ApproveSettlementModal
            isApproveSettlementModalOpen={isApprovedSettlementModalOpen}
            setIsApproveSettlementModalOpen={setIsApprovedSettlementModalOpen}
            settlementId={settlementId}
            setRefreshTable={setRefreshTable}
          />
          {isAdmin && (
            <PendingSettlementModal
              isPendingSettlementModalOpen={isPendingSettlementModalOpen}
              setIsPendingSettlementModalOpen={setIsPendingSettlementModalOpen}
              settlementId={settlementId}
              setRefreshTable={setRefreshTable}
            />
          )}

          {(!isAdmin && status === SettlementStatus.PENDING) || isAdmin ? (
            <div className='settlement-dropdown'>
              <Menu
                control={
                  <UnstyledButton
                    className={`status ${status.toLowerCase()}`}
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <div></div>
                    <div>{capitalized()}</div>
                    <ChevronDown size={16} strokeWidth={3} color={'white'} />
                  </UnstyledButton>
                }
              >
                {status === SettlementStatus.PENDING && (
                  <Menu.Item
                    onClick={() => setIsApprovedSettlementModalOpen(true)}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '.25rem',
                      }}
                    >
                      <CircleCheck
                        size={18}
                        strokeWidth={2}
                        color={'#1DC340'}
                      />
                      Done
                    </div>
                  </Menu.Item>
                )}
                {status === SettlementStatus.DONE && (
                  <Menu.Item
                    onClick={() => setIsPendingSettlementModalOpen(true)}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '.25rem',
                      }}
                    >
                      <CircleX size={18} strokeWidth={2} color={'#ec821e'} />
                      Pending
                    </div>
                  </Menu.Item>
                )}
              </Menu>
            </div>
          ) : (
            <>
              <Badge
                style={{ width: '120px' }}
                color={
                  status === SettlementStatus.PENDING
                    ? 'orange'
                    : status === SettlementStatus.DONE
                    ? 'green'
                    : 'grey'
                }
                size='md'
              >
                {capitalized()}
              </Badge>
            </>
          )}
        </>
      ) : (
        <>
          <Badge
            style={{ width: '120px' }}
            color={
              status === SettlementStatus.PENDING
                ? 'orange'
                : status === SettlementStatus.DONE
                ? 'green'
                : 'grey'
            }
            size='md'
          >
            {capitalized()}
          </Badge>
        </>
      )}
    </>
  );
}

export default SettlementStatusDropdown;
